export const API_KEY = "FtdCHUngqgk23Tpmk2yzaN2u4Y77VZbM3afWVnJQit2AYkufgjgjGXwbwMUz";
